export default "__VITE_ASSET__0110f969__"